<ion-header mode="md" class="ion-no-border">
    <ion-toolbar>
        @if (!isPaymentProcessing) {
        <button class="bg-transparent flex flex-col items-center justify-center size-10" (click)="onBackClicked()"
            slot="start"><ion-icon class="size-6" name="arrow-back"></ion-icon></button>
        }
        <ion-title>{{selectedPlan == null ? 'Upgrade Plan' : 'Complete your purchase'}}</ion-title>

    </ion-toolbar>
</ion-header>

<ion-content>



    <div class="max-w-screen-lg mx-auto">

        @if (selectedPlan == null) {
        <div>

            <h3 sxMargin="50px 0 30px 0" sxTextAlign="center" sxTextSize="large" sxTextWeight="bold">Choose Your Perfect
                Plan</h3>

            <ion-segment [(ngModel)]="paymentTerms" mode="ios">
                <ion-segment-button [value]="TimePeriod.MONTHLY">
                    <ion-label>Monthly</ion-label>
                </ion-segment-button>
                <ion-segment-button [value]="TimePeriod.YEARLY">
                    <ion-label>Annual</ion-label>
                </ion-segment-button>
            </ion-segment>


            <p class="text-center text-sm text-gray-500">Save 10% with annual plan</p>


            <div sxRow sxGap="15px" sxPadding="medium large">

                @for (plan of plans; track plan._id) {
                <div [class.featured]="false" sxRadius="medium" sxBackground="light" sxPadding="large"
                    sxBorderColor="one" sxBorderWidth="1px" sxWidth="fill">

                    <h1 sxTextAlign="left" sxTextSize="large" sxTextWeight="normal">{{plan.name}}</h1>

                    <p sxTextSize="38px" sxTextWeight="bold">₹{{getPrice(plan)}}</p>
                    <p sxMargin="0" sxTextSize="small" sxColor="two">
                        per month
                        @if (paymentTerms == TimePeriod.YEARLY) {
                        <span>, billed annually</span>
                        }
                    </p>

                    <div sxBackground="one" sxWidth="full" sxHeight="1px" sxMargin="20px 0 0"></div>

                    <div class="plan-features" sxMargin="10px 0">
                        <div class="feature-item">
                            <ion-icon name="albums-outline" class="feature-icon"></ion-icon>
                            <span>{{getFeatureQuota('create_share', plan)}} Collections</span>
                        </div>

                        <div class="feature-item">
                            <ion-icon name="document-text-outline" class="feature-icon"></ion-icon>
                            <span>{{getFeatureQuota('create_template', plan)}} Forms</span>
                        </div>
                        <div class="feature-item">
                            <ion-icon name="people-outline" class="feature-icon"></ion-icon>
                            <span>{{getFeatureQuota('add_org_user', plan)}} Users</span>
                        </div>
                        <div class="feature-item">
                            <ion-icon name="checkmark-circle" class="feature-icon"></ion-icon>
                            <span>API Integration</span>
                        </div>
                    </div>

                    <super-button size="small" sxWidth="full" class="plan-button" (click)="onChoosePlanClicked(plan)"
                        iconEnd="chevron-forward">
                        Choose Plan
                    </super-button>
                </div>

                }


            </div>



        </div>
        }





        @if (selectedPlan != null) {
        <div class="h-full py-6">

            <checkout class="h-full w-full" [plan]="selectedPlan" [paymentTerms]="paymentTerms"
                (processingStateChange)="isPaymentProcessing = $event" (onSuccess)="onCheckoutSuccess()"></checkout>
        </div>
        }
    </div>
</ion-content>